import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Renters Insurance by National Student Services, Inc. (NSSI)", -1)
const _hoisted_2 = {
  width: "100%",
  height: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_3 = { height: "100" }
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = { height: "80%" }
const _hoisted_6 = { class: "quotewizard" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"text-align":"center"}
}, " Assurant Legal ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  onclick: "window.history.back();"
}, "❮  Back", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Underwriters", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. These companies operate under the trade name Assurant. ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, " In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Underwriting Entities", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, " You are provided the following information pursuant to various state insurance laws, including, but not limited to, those of California, Massachusetts and Missouri. Each insurer has sole financial responsibility for its own products. ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "scrolltable" }, [
  /*#__PURE__*/_createElementVNode("table", {
    class: "styledtable",
    cellspacing: "0",
    cellpadding: "0"
  }, [
    /*#__PURE__*/_createElementVNode("tbody", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "Insurance Company")
        ]),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "National Association of Insurance Commissioners' ID #")
        ]),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "Jurisdictions in US Where Authorized to Do Business")
        ]),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "State of Domicile ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "American Bankers Insurance Company of Florida"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("11222 Quail Roost Drive"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Miami, FL 33157"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("span", null, "(305) 253-2244")
        ]),
        /*#__PURE__*/_createElementVNode("td", null, " 10111"),
        /*#__PURE__*/_createElementVNode("td", null, " All States & the District of Columbia"),
        /*#__PURE__*/_createElementVNode("td", null, " Florida")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "American Security Insurance Company"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("260 Interstate N Circle - SE"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Atlanta, GA 30339 "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("span", null, "(770) 763-1000")
        ]),
        /*#__PURE__*/_createElementVNode("td", null, " 42978"),
        /*#__PURE__*/_createElementVNode("td", null, " All States except NH"),
        /*#__PURE__*/_createElementVNode("td", null, " Delaware")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("strong", null, "Voyager Indemnity Insurance Company"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("260 Interstate N Circle - SE"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Atlanta, GA 30339 "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("span", null, "(770) 763-1000")
        ]),
        /*#__PURE__*/_createElementVNode("td", null, " 40428"),
        /*#__PURE__*/_createElementVNode("td", null, " Georgia"),
        /*#__PURE__*/_createElementVNode("td", null, " Georgia")
      ])
    ])
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { height: "80" }
const _hoisted_30 = {
  class: "quote-footer",
  style: {"text-align":"center"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://nssi.com/terms-of-use",
  target: "_blank"
}, "Terms of Use", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://nssi.com/privacy-policy",
  target: "_blank"
}, "Privacy Policy", -1)

import LoggedInBar from "@/views/partials/LoggedInBar.vue";
import MyLogo from "@/views/partials/RentersLogo.vue";
import { removeNoScroll } from "@/utils/NoScroll";
import { onMounted } from "vue";
import { getCurrentYear } from "@/utils/Utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'LegalAssurant',
  setup(__props) {

onMounted(() => {
  removeNoScroll();
  window.scrollTo(0, 0);
});

return (_ctx: any,_cache: any) => {
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(LoggedInBar),
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(MyLogo)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_5, [
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createTextVNode(" © " + _toDisplayString(_unref(getCurrentYear)) + " National Student Services, Inc. All Rights Rights Reserved.", 1),
              _hoisted_31,
              _hoisted_32,
              _createTextVNode("  |  "),
              _hoisted_33,
              _createTextVNode("  |  "),
              _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
                default: _withCtx(() => [
                  _createTextVNode("Assurant Legal")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})